import { useCallback } from "react";

/**
 * Chart type and resolution chosen in ChartTypeMenu, saved to the chart
 * settings. useChartEngine passes both to the engine: it draws the type and
 * reloads history when the effective resolution changes; Line always runs
 * on the smallest resolution (getEffectiveChartSettings).
 *
 * @param {{ settings: object, effectiveSettings: object, updateSettings: (partial: object) => void }} chartSettingsApi
 * @returns {{ chartType: number, resolution: string, setChartType: Function, setResolution: Function }}
 */
const useChartType = (chartSettingsApi) => {
  const { settings, effectiveSettings, updateSettings } = chartSettingsApi;

  const setChartType = useCallback((type) => updateSettings({ chartType: type }), [updateSettings]);

  const setResolution = useCallback(
    (resolution) => updateSettings({ resolution }),
    [updateSettings],
  );

  return {
    chartType: settings.chartType,
    resolution: effectiveSettings.resolution,
    setChartType,
    setResolution,
  };
};

export default useChartType;
